import { useCallback } from 'react';
import { SchemaFieldRenderer } from './SchemaFieldRenderer';
import { parseSchemaProperties, getDefaultValues } from '../../utils/schemaUtils';

interface DynamicSchemaFormProps {
  schema: Record<string, unknown>;
  values: Record<string, unknown>;
  onChange: (values: Record<string, unknown>) => void;
  errors?: Record<string, string>;
}

export function DynamicSchemaForm({
  schema,
  values,
  onChange,
  errors = {},
}: DynamicSchemaFormProps) {
  const properties = parseSchemaProperties(schema);

  const handleFieldChange = useCallback((name: string, value: unknown) => {
    onChange({
      ...values,
      [name]: value,
    });
  }, [values, onChange]);

  if (properties.length === 0) {
    return (
      <div className="text-center py-6 text-gray-500 dark:text-gray-400">
        <p>No input fields defined for this endpoint.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {properties.map((property) => (
        <SchemaFieldRenderer
          key={property.name}
          property={property}
          value={values[property.name]}
          onChange={handleFieldChange}
          error={errors[property.name]}
        />
      ))}
    </div>
  );
}

/**
 * Hook to initialize form values from schema defaults
 */
export function useSchemaFormValues(schema: Record<string, unknown> | null) {
  return getDefaultValues(schema);
}
